import { render, staticRenderFns } from "./cardtype.vue?vue&type=template&id=4b3e1550"
import script from "./cardtype.vue?vue&type=script&lang=js"
export * from "./cardtype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports